export default function () {
  const { scoringMethod } = this.reviewGroupInfo
  return [
    {
      title: '轮次序号',
      width: 76,
      [$field]: 'reviewRoundNum'
    },
    scoringMethod !== 'DFFS03' ? {
      title: '总分',
      width: 60,
      [$field]: 'objectCountScore'
    } : null,
    scoringMethod !== 'DFFS03' ? {
      title: '平均分',
      width: 70,
      [$field]: 'objectAvgScore'
    }: null,
    scoringMethod !== 'DFFS03' ? {
      title: '去极平均分',
      [$field]: 'objectDepAvgScore'
    }: null,
    {
      title: '操作',
      width: 80,
      [$field]: 'objectName',
      render: (h, {row}) => {
        return h('span', {
          'on': {
            'click': () => {
              this.getUserReviewInfo(row._index)
            }
          },
          class: 'iv-pointer iv-hover-color'
        }, '查看详情')
      }
    }
  ].filter(v => v)
}